import { IReduxStore } from "./ReduxStore";
import * as SidePanelActions from "../../actions/SidePanelActions";
import { updateDmn } from "../../actions/UpdateDmn";
import { EventBus } from "camunda-dmn-js";
import { PanelType } from "../State";

class DmnProvider {

    static _providers: any[] = [];
    widthModifier = 200;

    constructor(eventBus: EventBus, reduxStore: IReduxStore) {
        eventBus.on("commandStack.col.add.executed", () => {
            const currentWidth = reduxStore.getStore().uiState.panelSettings.elementPanel.width;
            const dispatch = reduxStore.getDispatch();
            dispatch(SidePanelActions.updatePanelWidth(PanelType.ElementPanel, currentWidth + this.widthModifier))
        })

        eventBus.on("col.remove", () => {
            const currentWidth = reduxStore.getStore().uiState.panelSettings.elementPanel.width;
            const dispatch = reduxStore.getDispatch();
            dispatch(SidePanelActions.updatePanelWidth(PanelType.ElementPanel, currentWidth - this.widthModifier))
        })
        eventBus.on("commandStack.changed", async () => {
            const dispatch = reduxStore.getDispatch();
            dispatch(updateDmn())
        });
    }

    registerProvider(provider: any) {
        DmnProvider._providers.push(provider);
    }
}

DmnProvider.$inject = [
    'eventBus',
    "reduxStore",
];

export default {
    __init__: ['dmnProvider'],
    dmnProvider: ['type', DmnProvider]
};